import { useNotificationBell } from "$global-providers/notifications-provider";
import { useState } from "react";
import { Bell } from "./bell";
import { NotificationPanel } from "./panel";

export const NotificationCenter: FC = () => {
  const [open, setOpen] = useState(false);
  const bell = useNotificationBell();

  const handleToggle = () => {
    if (!open) void bell.openBell();
    setOpen((prev) => !prev);
  };

  return (
    <>
      <Bell
        unreadCount={bell.unreadCount}
        actionRequiredCount={bell.actionRequiredCount}
        onClick={handleToggle}
      />
      <NotificationPanel
        open={open}
        onClose={() => setOpen(false)}
        notifications={bell.notifications}
        onMarkAllRead={bell.markAllRead}
        onDismiss={bell.dismissRow}
        // Activating a row bumps the bell-opened watermark so a row whose
        // `createdAt` arrived after the panel was opened doesn't keep the
        // unread dot/badge lit after the user has acted on it.
        onActivate={bell.openBell}
      />
    </>
  );
};
